"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
/*import PropTypes from 'prop-types'*/

const overlayStyle = {
  position: 'absolute',
  top: '0',
  right: '0',
  bottom: '0',
  left: '0',
  fontWeight: 'bold',
  borderWidth: '6px',
  opacity: '.82',
  backgroundColor: '#222222',
  fontSize: '1.8rem'
};
class Overlay extends _react.default.Component {
  constructor(props) {
    super(props);
    this.state = {
      hasMouseOver: false
    };
  }
  render() {
    const _this$props = this.props,
      children = _this$props.children,
      onEdit = _this$props.onEdit,
      onDelete = _this$props.onDelete;
    return /*#__PURE__*/_react.default.createElement("div", {
      className: "relative overlay",
      style: {
        cursor: 'pointer'
      },
      onMouseEnter: () => this.setState({
        hasMouseOver: true
      }),
      onMouseLeave: () => this.setState({
        hasMouseOver: false
      })
    }, children, this.state.hasMouseOver ? /*#__PURE__*/_react.default.createElement("div", {
      className: "h1 rounded z1 border border-pagenta px2",
      style: overlayStyle
    }, /*#__PURE__*/_react.default.createElement("div", {
      className: "table full-height col-12 center"
    }, /*#__PURE__*/_react.default.createElement("div", {
      className: "white table-cell align-middle"
    }, /*#__PURE__*/_react.default.createElement("button", {
      className: "btn m1 btn-edit",
      onClick: onEdit,
      title: "Editar"
    }, /*#__PURE__*/_react.default.createElement("i", {
      className: "fa fa-edit"
    })), /*#__PURE__*/_react.default.createElement("button", {
      className: "btn m1 btn-remove",
      onClick: onDelete,
      title: "Remover"
    }, /*#__PURE__*/_react.default.createElement("i", {
      className: "fa fa-trash"
    }))))) : null);
  }
}
var _default = exports.default = Overlay;